webpackJsonp([63],{

/***/ 100:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 101:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 102:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 103:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(189)
}
var Component = __webpack_require__(109)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(194),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);


__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.timeout = 10000;
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.headers.post['Content-Type'] = 'application/x-www=form-urlencoded';

// 设置生产环境 API 基础地址
if (true) {
  __WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.baseURL = "http://112.124.7.91:8086";
}

/* harmony default export */ __webpack_exports__["a"] = ({
  fetchGet: function fetchGet(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url, params).then(function (res) {
        resolve(res.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  fetchPost: function fetchPost(url) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, params).then(function (res) {
        resolve(res.data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
});

/***/ }),

/***/ 145:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_message_css__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_message_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_theme_default_message_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_default_notification_css__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_default_notification_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_default_notification_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_notification__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_loading_css__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_theme_default_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_loading__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_default_option_css__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_default_option_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_default_option_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_option__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_option___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_option__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_default_select_css__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_default_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui_lib_theme_default_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_select__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui_lib_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_default_dialog_css__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_default_dialog_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_default_dialog_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_dialog__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_default_input_css__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_default_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui_lib_theme_default_input_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_default_table_column_css__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_default_table_column_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui_lib_theme_default_table_column_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_table_column__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui_lib_table_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_table_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_default_table_css__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_default_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_default_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_table__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_element_ui_lib_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_default_step_css__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_default_step_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_default_step_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_step__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_element_ui_lib_step___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_step__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_theme_default_steps_css__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_element_ui_lib_theme_default_steps_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_element_ui_lib_theme_default_steps_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_steps__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui_lib_steps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_element_ui_lib_steps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_theme_default_autocomplete_css__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_element_ui_lib_theme_default_autocomplete_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_element_ui_lib_theme_default_autocomplete_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_autocomplete__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui_lib_autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_element_ui_lib_autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_theme_default_icon_css__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_theme_default_icon_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_element_ui_lib_theme_default_icon_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_icon__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_element_ui_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_element_ui_lib_theme_default_checkbox_css__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_element_ui_lib_theme_default_checkbox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_element_ui_lib_theme_default_checkbox_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_element_ui_lib_checkbox__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_element_ui_lib_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_element_ui_lib_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_element_ui_lib_theme_default_pagination_css__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_element_ui_lib_theme_default_pagination_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_element_ui_lib_theme_default_pagination_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_element_ui_lib_pagination__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_element_ui_lib_pagination___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_element_ui_lib_pagination__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_element_ui_lib_theme_default_button_css__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_element_ui_lib_theme_default_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_element_ui_lib_theme_default_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_element_ui_lib_theme_default_base_css__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_element_ui_lib_theme_default_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_element_ui_lib_theme_default_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_element_ui_lib_button__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_element_ui_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_element_ui_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__App__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__router__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__store___ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_vue_lazyload__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_vue_infinite_scroll__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_vue_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_vue_cookie__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__api__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__utils_storage__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_vue_content_placeholders__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__utils_disable_devtools__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__utils_disable_devtools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__utils_disable_devtools__);












































 // 禁用开发者工具（仅生产环境生效）
__WEBPACK_IMPORTED_MODULE_33_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_42_vue_content_placeholders__["default"]);
__WEBPACK_IMPORTED_MODULE_33_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_32_element_ui_lib_button___default.a);
__WEBPACK_IMPORTED_MODULE_33_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_29_element_ui_lib_pagination___default.a);
__WEBPACK_IMPORTED_MODULE_33_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_27_element_ui_lib_checkbox___default.a);
__WEBPACK_IMPORTED_MODULE_33_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_25_element_ui_lib_icon___default.a);
__WEBPACK_IMPORTED_MODULE_33_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_23_element_ui_lib_autocomplete___default.a);
__WEBPACK_IMPORTED_MODULE_33_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21_element_ui_lib_steps___default.a);
__WEBPACK_IMPORTED_MODULE_33_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19_element_ui_lib_step___default.a);
__WEBPACK_IMPORTED_MODULE_33_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17_element_ui_lib_table___default.a);
__WEBPACK_IMPORTED_MODULE_33_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_element_ui_lib_table_column___default.a);
__WEBPACK_IMPORTED_MODULE_33_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_element_ui_lib_input___default.a);
__WEBPACK_IMPORTED_MODULE_33_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_dialog___default.a);
__WEBPACK_IMPORTED_MODULE_33_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_element_ui_lib_select___default.a);
__WEBPACK_IMPORTED_MODULE_33_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_option___default.a);
__WEBPACK_IMPORTED_MODULE_33_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_loading___default.a.directive);
__WEBPACK_IMPORTED_MODULE_33_vue__["default"].prototype.$loading = __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_loading___default.a.service;
__WEBPACK_IMPORTED_MODULE_33_vue__["default"].prototype.$notify = __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_notification___default.a;
__WEBPACK_IMPORTED_MODULE_33_vue__["default"].prototype.$message = __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_message___default.a;
__WEBPACK_IMPORTED_MODULE_33_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_38_vue_infinite_scroll___default.a);
__WEBPACK_IMPORTED_MODULE_33_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_39_vue_cookie___default.a);
__WEBPACK_IMPORTED_MODULE_33_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_37_vue_lazyload__["a" /* default */], {
  // preLoad: 1.3,
  // error: 'dist/error.png',
  loading: '/static/images/load.gif'
  // attempt: 1
});
__WEBPACK_IMPORTED_MODULE_33_vue__["default"].config.productionTip = false;

// 设置index.html页面标题
var webName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_41__utils_storage__["a" /* getStore */])('webName');
if (webName) {
  document.title = webName;
}

var whiteList = ['/home', '/goods', '/login', '/register', '/goodsDetails', '/thanks', '/search', '/refreshsearch', '/refreshgoods', '/articles', '/articlesDetails', '/sites']; // 不需要登陆的页面
__WEBPACK_IMPORTED_MODULE_35__router__["a" /* default */].beforeEach(function (to, from, next) {
  var params = {
    params: {
      token: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_41__utils_storage__["a" /* getStore */])('token')
    }
  };
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_40__api__["a" /* userInfo */])(params).then(function (res) {
    if (res.result.state !== 1) {
      // 没登录
      if (whiteList.indexOf(to.path) !== -1 || to.path.startsWith('/help/')) {
        // 白名单
        next();
      } else {
        if (to.path.indexOf('/articlesDetails') !== -1) {
          next();
        } else {
          next('/login');
        }
      }
    } else {
      __WEBPACK_IMPORTED_MODULE_36__store___["a" /* default */].commit('RECORD_USERINFO', { info: res.result });
      if (to.path === '/login') {
        //  跳转到
        next({ path: '/' });
      }
      next();
    }
  });
});
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_33_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_36__store___["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_35__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_34__App___default.a);
  }
});

__WEBPACK_IMPORTED_MODULE_33_vue__["default"].filter('statusText', function (value) {
  var statusMap = {
    '1': '已发布',
    '0': '草稿',
    '2': '已下架'
  };
  return statusMap[value] || value;
});

/***/ }),

/***/ 146:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ 147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INIT_BUYCART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GET_USERINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RECORD_USERINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ADD_ANIMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SHOW_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return REDUCE_CART; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return EDIT_CART; });
var INIT_BUYCART = 'INIT_BUYCART';
var ADD_CART = 'ADD_CART';
var GET_USERINFO = 'GET_USERINFO';
var RECORD_USERINFO = 'RECORD_USERINFO';
var ADD_ANIMATION = 'ADD_ANIMATION';
var SHOW_CART = 'SHOW_CART';
var REDUCE_CART = 'REDUCE_CART';
var EDIT_CART = 'EDIT_CART';

/***/ }),

/***/ 148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_storage__ = __webpack_require__(25);



var _INIT_BUYCART$ADD_CAR;



/* harmony default export */ __webpack_exports__["a"] = (_INIT_BUYCART$ADD_CAR = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["a" /* INIT_BUYCART */], function (state) {
  var initCart = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["a" /* getStore */])('buyCart');
  if (initCart) {
    state.cartList = JSON.parse(initCart);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["b" /* ADD_CART */], function (state, _ref) {
  var productId = _ref.productId,
      salePrice = _ref.salePrice,
      productName = _ref.productName,
      productImg = _ref.productImg,
      _ref$productNum = _ref.productNum,
      productNum = _ref$productNum === undefined ? 1 : _ref$productNum;

  var cart = state.cartList; // 购物车
  var falg = true;
  var goods = {
    productId: productId,
    salePrice: salePrice,
    productName: productName,
    productImg: productImg
  };
  if (cart.length) {
    // 有内容
    cart.forEach(function (item) {
      if (item.productId === productId) {
        if (item.productNum >= 0) {
          falg = false;
          item.productNum += productNum;
        }
      }
    });
  }
  if (!cart.length || falg) {
    goods.productNum = productNum;
    goods.checked = '1';
    cart.push(goods);
  }
  state.cartList = cart;
  // 存入localStorage
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["b" /* setStore */])('buyCart', cart);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["c" /* ADD_ANIMATION */], function (state, _ref2) {
  var moveShow = _ref2.moveShow,
      elLeft = _ref2.elLeft,
      elTop = _ref2.elTop,
      img = _ref2.img,
      cartPositionT = _ref2.cartPositionT,
      cartPositionL = _ref2.cartPositionL,
      receiveInCart = _ref2.receiveInCart;

  state.showMoveImg = moveShow;
  if (elLeft) {
    state.elLeft = elLeft;
    state.elTop = elTop;
  }
  state.moveImgUrl = img;
  state.receiveInCart = receiveInCart;
  if (cartPositionT) {
    state.cartPositionT = cartPositionT;
    state.cartPositionL = cartPositionL;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["d" /* SHOW_CART */], function (state, _ref3) {
  var showCart = _ref3.showCart;

  // let timer = null
  state.showCart = showCart;
  // clearTimeout(timer)
  // if (showCart) {
  //   timer = setTimeout(() => {
  //     state.showCart = false
  //   }, 5000)
  // }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["e" /* REDUCE_CART */], function (state, _ref4) {
  var productId = _ref4.productId;

  var cart = state.cartList;
  cart.forEach(function (item, i) {
    if (item.productId === productId) {
      if (item.productNum > 1) {
        item.productNum--;
      } else {
        cart.splice(i, 1);
      }
    }
  });
  state.cartList = cart;
  // 存入localStorage
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["b" /* setStore */])('buyCart', state.cartList);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["f" /* EDIT_CART */], function (state, _ref5) {
  var productId = _ref5.productId,
      productNum = _ref5.productNum,
      checked = _ref5.checked;

  var cart = state.cartList;
  if (productNum) {
    cart.forEach(function (item, i) {
      if (item.productId === productId) {
        item.productNum = productNum;
        item.checked = checked;
      }
    });
  } else if (productId) {
    cart.forEach(function (item, i) {
      if (item.productId === productId) {
        cart.splice(i, 1);
      }
    });
  } else {
    cart.forEach(function (item) {
      item.checked = checked ? '1' : '0';
    });
  }
  state.cartList = cart;
  // 存入localStorage
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["b" /* setStore */])('buyCart', state.cartList);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["g" /* RECORD_USERINFO */], function (state, info) {
  state.userInfo = info;
  state.login = true;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_storage__["b" /* setStore */])('userInfo', info);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_INIT_BUYCART$ADD_CAR, __WEBPACK_IMPORTED_MODULE_2__mutation_types__["h" /* GET_USERINFO */], function (state, info) {
  if (state.userInfo && state.userInfo.username !== info.username) {
    return;
  }
  if (!state.login) {
    return;
  }
  if (!info.message) {
    state.userInfo = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, info);
  } else {
    state.userInfo = null;
  }
}), _INIT_BUYCART$ADD_CAR);

/***/ }),

/***/ 149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 188:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 189:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 194:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    staticClass: "main"
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/element-icons.b02bdc1.ttf";

/***/ }),

/***/ 201:
/***/ (function(module, exports) {

module.exports = "data:application/font-woff;base64,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"

/***/ }),

/***/ 25:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return removeStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/**
 * 存储localStorage
 */
var setStore = function setStore(name, content) {
  if (!name) return;
  if (typeof content !== 'string') {
    content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(content);
  }
  window.localStorage.setItem(name, content);
};

/**
 * 获取localStorage
 */
var getStore = function getStore(name) {
  if (!name) return;
  return window.localStorage.getItem(name);
};

/**
 * 删除localStorage
 */
var removeStore = function removeStore(name) {
  if (!name) return;
  window.localStorage.removeItem(name);
};

/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return sendRegisterCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return userLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loginOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return userInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return register; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return upload; });
/* unused harmony export updateheadimage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return thanksList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return productHome; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return navList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return recommend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return thank; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return geetest; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__public__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);


// 发送手机短信验证码
var sendRegisterCode = function sendRegisterCode(params) {
  return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('http://112.124.7.91:3002/api/web/sms/send-register-code', params, {
    headers: { 'Content-Type': 'application/json' }
  }).then(function (res) {
    return res.data;
  });
};
// 登陆
var userLogin = function userLogin(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].fetchPost('/member/login', params);
};
// 退出登陆
var loginOut = function loginOut(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].fetchGet('/member/loginOut', params);
};
// 用户信息
var userInfo = function userInfo(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].fetchGet('/member/checkLogin', params);
};
// 注册账号
var register = function register(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].fetchPost('/member/register', params);
};
// 上传图片
var upload = function upload(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].fetchPost('/member/imgaeUpload', params);
};
// 修改头像
var updateheadimage = function updateheadimage(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].fetchPost('/member/updateheadimage', params);
};
// 捐赠列表
var thanksList = function thanksList(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].fetchGet('/member/thanks', params);
};
// 首页接口
var productHome = function productHome(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].fetchGet('/goods/home', params);
};
// 首页接口
var navList = function navList(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].fetchGet('/goods/navList', params);
};
// 推荐板块
var recommend = function recommend(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].fetchGet('/goods/recommend', params);
};
// 捐赠板块
var thank = function thank(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].fetchGet('/goods/thank', params);
};
// 极验验证码
var geetest = function geetest(params) {
  return __WEBPACK_IMPORTED_MODULE_0__public__["a" /* default */].fetchGet('/member/geetestInit?t=' + new Date().getTime(), params);
};

/***/ }),

/***/ 72:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(195);


var Index = function Index() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 263));
};
var Login = function Login() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 237));
};
var Register = function Register() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 238));
};
var Home = function Home() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 236));
};
var GoodS = function GoodS() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 206));
};
var goodsDetails = function goodsDetails() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 207));
};
var Cart = function Cart() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 204));
};
var order = function order() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 245));
};
var user = function user() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 262));
};
var orderList = function orderList() {
  return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 259));
};
var information = function information() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 258));
};
var addressList = function addressList() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 255));
};
var coupon = function coupon() {
  return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 257));
};
var aihuishou = function aihuishou() {
  return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 256));
};
var support = function support() {
  return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 261));
};
var checkout = function checkout() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 205));
};
var payment = function payment() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 246));
};
var paysuccess = function paysuccess() {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 247));
};
var Thanks = function Thanks() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 254));
};
var Search = function Search() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 252));
};
var RefreshSearch = function RefreshSearch() {
  return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 251));
};
var RefreshGoods = function RefreshGoods() {
  return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 250));
};
var orderDetail = function orderDetail() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 260));
};
var Alipay = function Alipay() {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 244));
};
var Wechat = function Wechat() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 249));
};
var QQpay = function QQpay() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 248));
};
var Articles = function Articles() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 203));
};
var articlesDetails = function articlesDetails() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 202));
};
var Sites = function Sites() {
  return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, 253));
};
// 商家街
var Merchant = function Merchant() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 241));
};
var MerchantDetail = function MerchantDetail() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 242));
};
// 商家入驻
var MerchantApplication = function MerchantApplication() {
  return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 239));
};
// 商城资质
var MerchantCertificate = function MerchantCertificate() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 240));
};

//商家管理中心登录
var MerchantLogin = function MerchantLogin() {
  return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, 243));
};
// 使用帮助页面
var Help = function Help() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 235));
};

// 动态导入帮助页面组件
var HelpPages = {
  help1: function help1() {
    return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, 208));
  }, // 会员制度
  help2: function help2() {
    return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 219));
  }, // 积分说明
  help3: function help3() {
    return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 228));
  }, // 交易条款
  help4: function help4() {
    return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 229));
  }, // 购物流程
  help5: function help5() {
    return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 230));
  }, // 订单状态
  help6: function help6() {
    return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 231));
  }, // 购物流程
  help7: function help7() {
    return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 232));
  }, // 购物流程
  help8: function help8() {
    return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 233));
  }, //银行电汇
  help9: function help9() {
    return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 234));
  }, // 余额支付
  help10: function help10() {
    return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 209));
  }, // 支付帮助
  help11: function help11() {
    return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 210));
  }, // 付费咨询
  help12: function help12() {
    return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 211));
  }, //换货说明
  help13: function help13() {
    return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 212));
  }, //退/换货说明
  help14: function help14() {
    return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 213));
  }, //余额的使用与提现
  help15: function help15() {
    return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 214));
  }, //发票制度
  help16: function help16() {
    return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 215));
  }, //售后服务
  help17: function help17() {
    return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 216));
  }, //配送范围及运费
  help18: function help18() {
    return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 217));
  }, //上门自提
  help19: function help19() {
    return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 218));
  }, //加急快递
  help20: function help20() {
    return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 220));
  }, //商品验货与签收
  help21: function help21() {
    return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 221));
  }, //联系客服
  help22: function help22() {
    return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 222));
  }, //关于我们
  help23: function help23() {
    return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 223));
  }, //常见问题
  help24: function help24() {
    return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 224));
  }, //找回密码
  help25: function help25() {
    return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 225));
  }, //退订邮件/短信
  help26: function help26() {
    return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 226));
  }, //用户服务协议
  help27: function help27() {
    return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 227));
  } //隐私条款
};
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    component: Index,
    name: 'index',
    redirect: '/home',
    children: [{
      path: 'home',
      component: Home
    }, {
      path: 'goods',
      component: GoodS
    }, {
      path: 'goodsDetails',
      name: 'goodsDetails',
      component: goodsDetails
    }, {
      path: 'articles',
      component: Articles
    }, {
      path: 'merchant',
      component: Merchant
    }, {
      path: 'merchantDetail/:id',
      component: MerchantDetail
    }, {
      path: 'merchantApplication',
      component: MerchantApplication
    }, {
      path: 'merchantcertificate',
      component: MerchantCertificate
    }, {
      path: 'sites',
      component: Sites
    }, {
      path: '/articlesDetails/:id',
      name: 'articlesDetails',
      component: articlesDetails
    }, {
      path: 'thanks',
      name: 'thanks',
      component: Thanks
    }, {
      path: '/refreshgoods',
      name: 'refreshgoods',
      component: RefreshGoods
    }]
  }, {
    path: '/login',
    name: 'login',
    component: Login
  }, {
    path: '/register',
    name: 'register',
    component: Register
  }, {
    path: '/cart',
    name: 'cart',
    component: Cart
  }, {
    path: '/refreshsearch',
    name: 'refreshsearch',
    component: RefreshSearch
  }, {
    path: '/order',
    name: 'order',
    component: order,
    children: [{
      path: 'paysuccess',
      name: 'paysuccess',
      component: paysuccess
    }, {
      path: 'payment',
      name: 'payment',
      component: payment
    }, {
      path: '/search',
      name: 'search',
      component: Search
    }, {
      path: 'alipay',
      name: 'alipay',
      component: Alipay
    }, {
      path: 'wechat',
      name: 'wechat',
      component: Wechat
    }, {
      path: 'qqpay',
      name: 'qqpay',
      component: QQpay
    }]
  }, {
    path: '/user',
    name: 'user',
    component: user,
    redirect: '/user/orderList',
    children: [{
      path: 'orderList',
      name: '订单列表',
      component: orderList
    }, {
      path: 'orderDetail',
      name: '订单详情',
      component: orderDetail
    }, {
      path: 'information',
      name: '账户资料',
      component: information
    }, {
      path: 'addressList',
      name: '收货地址',
      component: addressList
    }, {
      path: 'coupon',
      name: '我的优惠',
      component: coupon
    }, {
      path: 'support',
      name: '售后服务',
      component: support
    }, {
      path: 'aihuishou',
      name: '以旧换新',
      component: aihuishou
    }]
  }, {
    path: '/help',
    name: 'help',
    component: Help,
    redirect: '/help/help1',
    children: [{
      path: 'help1',
      name: '会员制度',
      component: HelpPages.help1
    }, {
      path: 'help2',
      name: '积分说明',
      component: HelpPages.help2
    }, {
      path: 'help3',
      name: '交易条款',
      component: HelpPages.help3
    }, {
      path: 'help4',
      name: '购物流程',
      component: HelpPages.help4
    }, {
      path: 'help5',
      name: '订单状态',
      component: HelpPages.help5
    }, {
      path: 'help6',
      name: '货到付款',
      component: HelpPages.help6
    }, {
      path: 'help7',
      name: '在线支付',
      component: HelpPages.help7
    }, {
      path: 'help8',
      name: '银行电汇',
      component: HelpPages.help8
    }, {
      path: 'help9',
      name: '余额支付',
      component: HelpPages.help9
    }, {
      path: 'help10',
      name: '支付帮助',
      component: HelpPages.help10
    }, {
      path: 'help11',
      name: '付费咨询',
      component: HelpPages.help11
    }, {
      path: 'help12',
      name: '换货说明',
      component: HelpPages.help12
    }, {
      path: 'help13',
      name: '退/换货说明',
      component: HelpPages.help13
    }, {
      path: 'help14',
      name: '余额的使用与提现',
      component: HelpPages.help14
    }, {
      path: 'help15',
      name: '发票制度',
      component: HelpPages.help15
    }, {
      path: 'help16',
      name: '售后服务',
      component: HelpPages.help16
    }, {
      path: 'help17',
      name: '配送范围及运费',
      component: HelpPages.help17
    }, {
      path: 'help18',
      name: '上门自提',
      component: HelpPages.help18
    }, {
      path: 'help19',
      name: '加急快递',
      component: HelpPages.help19
    }, {
      path: 'help20',
      name: '商品验货与签收',
      component: HelpPages.help20
    }, {
      path: 'help21',
      name: '联系客服',
      component: HelpPages.help21
    }, {
      path: 'help22',
      name: '关于我们',
      component: HelpPages.help22
    }, {
      path: 'help23',
      name: '常见问题',
      component: HelpPages.help23
    }, {
      path: 'help24',
      name: '找回密码',
      component: HelpPages.help24
    }, {
      path: 'help25',
      name: '退订邮件/短信',
      component: HelpPages.help25
    }, {
      path: 'help26',
      name: '用户服务协议',
      component: HelpPages.help26
    }, {
      path: 'help27',
      name: '隐私条款',
      component: HelpPages.help27
    }]
  }, {
    path: '/checkout',
    name: 'checkout',
    component: checkout
  }, {
    path: '/merchantLogin',
    name: 'merchantLogin',
    component: MerchantLogin
  }, {
    path: '*',
    redirect: '/home'
  }]
}));

/***/ }),

/***/ 73:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action__ = __webpack_require__(146);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
  login: false, // 是否登录
  userInfo: null, // 用户信息
  cartList: [], // 加入购物车列表
  showMoveImg: false, // 显示飞入图片
  elLeft: 0,
  elTop: 0,
  moveImgUrl: null,
  cartPositionT: 0, // 购物车位置
  cartPositionL: 0,
  receiveInCart: false, // 是否进入购物车
  showCart: false // 是否显示购物车
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  action: __WEBPACK_IMPORTED_MODULE_3__action__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */]
}));

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

/**
 * 禁用开发者工具
 * 仅在生产环境生效
 */

// 检测是否为生产环境
var isProduction = "production" === 'production';

if (isProduction) {
  // 1. 禁用右键菜单
  document.addEventListener('contextmenu', function (e) {
    e.preventDefault();
    return false;
  });

  // 2. 禁用快捷键
  document.addEventListener('keydown', function (e) {
    // F12
    if (e.keyCode === 123) {
      e.preventDefault();
      return false;
    }
    // Ctrl+Shift+I (开发者工具)
    if (e.ctrlKey && e.shiftKey && e.keyCode === 73) {
      e.preventDefault();
      return false;
    }
    // Ctrl+Shift+J (控制台)
    if (e.ctrlKey && e.shiftKey && e.keyCode === 74) {
      e.preventDefault();
      return false;
    }
    // Ctrl+Shift+C (元素选择器)
    if (e.ctrlKey && e.shiftKey && e.keyCode === 67) {
      e.preventDefault();
      return false;
    }
    // Ctrl+U (查看源码)
    if (e.ctrlKey && e.keyCode === 85) {
      e.preventDefault();
      return false;
    }
    // Ctrl+S (保存)
    if (e.ctrlKey && e.keyCode === 83) {
      e.preventDefault();
      return false;
    }
  });

  // 3. 检测开发者工具是否打开
  var devtools = { open: false };
  var threshold = 160;

  var checkDevTools = function checkDevTools() {
    var widthThreshold = window.outerWidth - window.innerWidth > threshold;
    var heightThreshold = window.outerHeight - window.innerHeight > threshold;

    if (widthThreshold || heightThreshold) {
      if (!devtools.open) {
        devtools.open = true;
        // 检测到开发者工具打开，可以执行一些操作
        console.clear();
        // 可选：重定向或显示警告
        // window.location.href = 'about:blank'
        // alert('请关闭开发者工具')
      }
    } else {
      devtools.open = false;
    }
  };

  // 定期检测
  setInterval(checkDevTools, 500);

  // 4. debugger 陷阱（可选，可能会影响性能）
  var startTime = new Date();
  debugger;
  var endTime = new Date();

  // 如果 debugger 暂停时间过长，说明开发者工具打开
  if (endTime - startTime > 100) {
    window.location.href = 'about:blank';
  }

  // 5. 禁用 console（可选）
  // window.console = {
  //   log: function () {},
  //   warn: function () {},
  //   error: function () {},
  //   info: function () {},
  //   debug: function () {},
  //   table: function () {},
  //   clear: function () {}
  // }

  // 6. 检测 Firebug
  if (window.console && window.console.firebug) {
    window.location.href = 'about:blank';
  }

  // 7. 禁用选择文本
  document.addEventListener('selectstart', function (e) {
    e.preventDefault();
    return false;
  });

  // 8. 禁用拖拽
  document.addEventListener('dragstart', function (e) {
    e.preventDefault();
    return false;
  });

  console.log('开发者工具保护已启用');
}

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 89:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 90:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 91:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 92:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 93:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 94:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 95:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 96:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 97:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 98:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 99:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[145]);


// WEBPACK FOOTER //
// static/js/app.a9ee3922229c9c6c4ff1.js